import { styled } from "styletron-react";

const BorderedContainer = styled("div", {
  textAlign: "center",
  borderTop: "1px solid #000000",
  borderBottom: "1px solid #000000",
});

export { BorderedContainer };
